import React from 'react';
import { pathwaysData } from '../data/pathwaysData';
import PathwayBlock from './PathwayBlock';
import './PathwaysSection.css';

function PathwaysSection() {
    return (
        <section id="pathways-section" className="pathways-section">
            <h2>Professional Development Pathways</h2>
            <p className="section-intro">Follow a curated journey from foundational skills to advanced leadership. Each pathway is a comprehensive program designed for deep, sustained professional growth.</p>

            {pathwaysData.map(pathway => (
                <div key={pathway.id} className="pathway-container">
                    <header className="pathway-header">
                        <div className="pathway-icon">{pathway.icon}</div>

                        <h3>{pathway.name}</h3>
                        <p>{pathway.description}</p>

                        <div className="pathway-tagline">{pathway.tagline}</div>
                    </header>

                    <div className="pathway-blocks-container">
                        {pathway.modules.map((module, index) => (
                            <PathwayBlock
                                key={index}
                                title={module.title}
                                details={module.details}
                                workshops={module.workshops}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </section>
    );
}

export default PathwaysSection;